import { Suggestion } from './suggestion';
export * from './findSuggestionMatch';
export * from './suggestion';
export default Suggestion;

//# sourceMappingURL=index.js.map